<template>
  <svg className="svg-icon" :class="iconClass" aria-hidden="true">
    <use :xlink:href="iconName" :style="{ fill: hoverColor }" />
  </svg>
</template>
<style>
.svg-icon {
  width: 1.5em;
  height: 1.5em;
}
</style>
<script>
export default {
  props: {
    iconClass: {
      type: String,
      required: true
    },
    hoverColor: {
      type: String,
      default: '#000'
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`
    }
  }
}
</script>
